<template>
    <div id="fast-wizard">
        <a-steps v-model="current" type="navigation" :style="stepStyle">
            <a-step :status="getStatus(0)" :title="$t('fastWizard.moreInfo')" />
            <a-step :status="getStatus(1)" :title="$t('fastWizard.display')" />
            <a-step :status="getStatus(2)" :title="$t('fastWizard.availability')" />
            <a-step :status="getStatus(3)" :title="$t('fastWizard.preview')" />
            <a-step :status="getStatus(4)" :title="$t('fastWizard.installCode')" />
        </a-steps>

        <div class="d-flex justify-content-center">
            <div v-show="current === 0" class="step step0">
                <MoreDetail />
            </div>
            <div v-show="current === 1" class="step step1">
                <DisplayConfig />
            </div>
            <div v-show="current === 2" class="step step2">
                <AvailabilityConfig />
            </div>
            <div v-show="current === 3" class="step step3">
                <Preview />
            </div>
            <div v-if="current === 4" class="step step4">
                <InstallCode />
            </div>
        </div>
        <div class="wizard-footer">
            <div>
                <a-button type="primary" ghost size="large" v-if="current > 0" @click="current = current - 1">
                    <a-icon type="left" />
                    {{ $t("fastWizard.previous") }}
                </a-button>
            </div>
            <h4>{{ $t("fastWizard.setupSupsisLiveChat") }}</h4>
            <div>
                <a-button type="primary" ghost size="large" v-if="current < 4" @click="current = current + 1">
                    {{ $t("fastWizard.continue") }}
                    <a-icon type="right" />
                </a-button>
                <a-button type="primary" size="large" v-else @click="complete" :disabled="waiting">
                    {{ $t("fastWizard.completeInitialize") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { sendSocketMessage } from "../../utils/socketStream";
import log2 from "../../utils/log2";
import DisplayConfig from "./DisplayConfig";
import AvailabilityConfig from "./AvailabilityConfig";
import Preview from "./Preview";
import Bubble1 from "../svg/bubbles/Bubble1";
import Bubble2 from "../svg/bubbles/Bubble2";
import Bubble3 from "../svg/bubbles/Bubble3";
import Bubble4 from "../svg/bubbles/Bubble4";
import Bubble5 from "../svg/bubbles/Bubble5";
import Bubble6 from "../svg/bubbles/Bubble6";
import Bubble7 from "../svg/bubbles/Bubble7";
import Bubble8 from "../svg/bubbles/Bubble8";
import LivePreview from "./LivePreview";
import MoreDetail from "./MoreDetail";
import InstallCode from "./InstallCode";

const log = log2("FastWizard");
export default {
    name: "FastWizard",
    components: {
        MoreDetail,
        DisplayConfig,
        AvailabilityConfig,
        Preview,
        InstallCode,
        LivePreview,
        Bubble1,
        Bubble2,
        Bubble3,
        Bubble4,
        Bubble5,
        Bubble6,
        Bubble7,
        Bubble8,
    },
    data() {
        return {
            iframeLoading: true,
            current: 0,
            stepStyle: {
                marginBottom: "60px",
                boxShadow: "0px -1px 0 0 #e8e8e8 inset",
            },
            waiting: false,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        async complete() {
            log("complete");
            this.waiting = true;
            const newSettings = await this.setSettingValue({
                setting: "initialized",
                value: true,
            });
            this.applySettings(newSettings);
            this.waiting = false;
            this.$message.success(this.$t("fastWizard.completedMessage"));
        },
        bubbleIcon() {
            let { customIcon } = this.settings.bubble;
            if (this.newIcon || customIcon) {
                let { path, _id, ext } = this.newIcon || customIcon;
                return `https://static.supsis.live/${path + _id}${ext ? "." + ext : ""}`;
            }
            return undefined;
        },
        getStatus(order) {
            if (order < this.current) return "finish";
            if (order === this.current) return "process";
            return "wait";
        },
        applySettings(newSettings) {
            this.updateSettings(newSettings).then(() => {
                sendSocketMessage("user settings-updated", {
                    siteId: this.site._id,
                });
            });
        },
    },
    watch: {
        current(val) {
            log("current changed", val);
        },
    },
};
</script>

<style lang="scss">
.ant-select-dropdown {
    z-index: 999999999999 !important;
}
</style>
